<template>
    <div class="kgk-password-forgotten">
        <template v-if="mode == 'retry-reset'">
            <p>Zurücksetzcode fehlerhaft – Prozess hier <a href="#" @click.prevent="passwordForgottenLink()">erneut starten.</a></p>
        </template>
        <template v-else>
            <p>Ich habe mein <a href="#" @click.prevent="passwordForgottenLink()">Passwort vergessen.</a></p>
        </template>
    </div>
</template>

<script>
    import PasswordForgottenForm from './PasswordForgottenForm';

    export default {
        name: 'PasswordForgotten',
        props: {
            mode: {
                type: String,
                required: false,
                default: null
            }
        },
        data() {
            return {

            }
        },
        computed: {

        },
        methods: {
            passwordForgottenLink() {
                const _this = this;

                const modalSaveTrigger = {
                    trigger: 0
                };

                const saveButtonText = 'Zurücksetzen';
                const saveButton = {
                    title: saveButtonText,
                    handler() {
                        ++modalSaveTrigger.trigger;
                    },
                    default: true,
                };

                this.$modal.show('dialog', {
                    title: 'Passwort vergessen',
                    component: PasswordForgottenForm,
                    props: {
                        insideModal: true,
                        modalSaveTrigger: modalSaveTrigger
                    },
                    on: {
                        requested: _this.handleRequested,
                        loadingStarted() {
                            saveButton.title = saveButtonText + ' <i class="fas fa-spinner fa-spin"></i>';
                        },
                        loadingEnded() {
                            saveButton.title = saveButtonText;
                        },
                        modalForceClose() {
                            _this.$modal.hide('dialog');
                        }
                    },
                    buttons: [
                        {
                            title: 'Abbrechen',
                            /*handler() {
                                _this.$modal.hide('dialog');
                            }*/
                        },
                        saveButton
                    ]
                });
            },
            handleRequested() {
                //console.log('handleSelection', selectedUsers, this);
                //this.selection = selectedUsers;

                this.$modal.hide('dialog');

                this.$emit('created');
            },
        },
        mounted() {

        }
    }
</script>
